<template>
  <b-container class="center_body">
    <div class="center_list">
      <!--  头部  -->
      <b-row class="diary_body">
        <b-col class="diary_title" lg="6" xl="6" sm="12" md="6">
          NORC2022-06 基金委南海中部
        </b-col>
        <b-col class="diary_time" lg="6" xl="6" sm="12" md="6">
          1 月 2022
        </b-col>
      </b-row>
      <!--  列表  -->
      <div>
        <div class="mt-4 content_body" v-for="(item, index) in dataSource" :key="item.id">
          <template v-if="index%2 == 0">
            <b-card :title="item.title" :img-src="item.img" img-alt="Card image" img-left class="mb-3 content_card">
              <b-card-text class="content_text">
                {{ item.content}}
              </b-card-text>
              <b-button>more</b-button>
            </b-card>
          </template>
          <template v-else>
            <b-card :title="item.title" :img-src="item.img" img-alt="Card image" img-right class="mb-3 content_card">
              <b-card-text class="content_text">
                {{ item.content}}
              </b-card-text>
              <b-button>more</b-button>
            </b-card>
          </template>
        </div>
      </div>
    </div>
    <link-component></link-component>
  </b-container>
</template>

<script>
import {dataLists} from '../../mock/diary'
import LinkComponent from '../../components/LinkComponent.vue';
export default {
  // name: "about",
  components: {
    LinkComponent,
  },
  props: {},
  computed: {},
  data() {
    return {
      dataSource:'',
    };
  },
  //       computed: {
  // },
  mounted() {
    this.getList();
  },
  methods: {
    getList(){
      // this.data = this.$route.params.data
      // if(this.$route.params.data === undefined){
      //   this.$router.push({ name: 'diary_list'});
      // }
      this.dataSource = dataLists()
      console.log('全数据', this.dataSource)
    }
  },
};
</script>

<style lang="less" scoped>
.center_body{
  margin-top: 20px;
  .center_list{
    border: 1px solid rgba(0,0,0,.125);
  }
}
.diary_body{
  border-bottom: 1px solid rgba(0,0,0,.125);
  margin: 20px;
  @media (min-width: 1200px) {
    display: flex;
    justify-content: space-between;
  }
  .diary_title{
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-size: 1.5rem;
  }
  .diary_time{
    text-align: right;
  }
}
.content_body{
  margin: 1.5rem 20px 20px 20px;
  .card-title{
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: normal;
    font-size: 18px;
  }
  .content_card{
    display: flex;
    flex-wrap: wrap;
    .card-img-left{
      width: 100%;
      @media (min-width: 1200px) {
        width: 40%;
      }
      @media (max-width: 1199px) {
        padding: 1rem;
      }
    }
    .card-img-right{
      width: 100%;
      @media (max-width: 1199px) {
        padding: 1rem;
      }
      @media (min-width: 1200px) {
        width: 40%;
      }
    }
    .card-body{
      flex: 1;
      .content_text{
        width: 100%;
        height: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 8;
        -webkit-box-orient: vertical;
      }
    }
  }

}
</style>
